import { Link } from 'react-router-dom';

// assets
import psaIcon from '../../../../../assets/system/logos/psa-logo-light.png';

// components
import HeaderBtn from '../header-btn/HeaderBtn';

export default function HeaderPSAPill({ navigateTo }) {
    return (
        <Link to={navigateTo} style={{ textDecoration: 'none', color: 'inherit' }}>
            <HeaderBtn>
                <img src={psaIcon} alt='PSA icon' />
            </HeaderBtn>
        </Link>
    );
}
